import Skeleton from "../Skeleton";
import PercentageBadge from "./PercentageBadge";

const MetricStatBlock = ({
    title,
    titleColor,
    actualValue,
    previousValue,
    percentageValue,
    isLoss = false,
    loading = false,
    badgeDecimals = 0,
    containerClassName = '',
    titleClassName = '',
    actualClassName = '',
    previousClassName = '',
    skeletonClassName = '',
}) => {
    const hasActualValue = actualValue !== null && actualValue !== undefined;
    const hasPreviousValue = previousValue !== null && previousValue !== undefined;

    return (
        <div className={containerClassName}>
            <div className={titleClassName} style={titleColor ? { color: titleColor } : undefined}>{title}</div>

            {!loading && hasActualValue && (
                <div className={actualClassName}>
                    {actualValue}
                    <PercentageBadge value={percentageValue} isLoss={isLoss} decimals={badgeDecimals} />
                </div>
            )}

            {!loading && hasPreviousValue && (
                <div className={previousClassName}>
                    {previousValue} nel periodo precedente
                </div>
            )}

            {loading && (
                <div className={skeletonClassName} style={{ marginTop: '0.5rem' }}>
                    <Skeleton height={24} width={'70%'} borderRadius={8} />
                    <Skeleton height={12} width={'100%'} borderRadius={8} />
                </div>
            )}
        </div>
    );
};

export default MetricStatBlock;
